import { createAction, props } from '@ngrx/store';
import { PhoneTypes } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { PhoneDetailSaveModel } from '../models/phone-detail-save.model';
import { PhoneRegisterListItem } from '../../phones/models/phone-register-results.model';

export const savePhone = createAction('[Create Extension] Create Phone', props<{ phoneSave: PhoneDetailSaveModel }>());

export const savePhoneSuccess = createAction('[API] Create Phone Success', props<{ phoneType: PhoneTypes }>());

export const savePhoneFailure = createAction('[API] Create Phone Failure', props<SingleGraphError>());

export const addPhoneToRegister = createAction('[Create Extension] Add Phone To Register', props<{ phone: PhoneRegisterListItem }>());
